export const OrderLoc = {
    searchOrderPlaceholder: {
        ru: 'Введите номер заказа',
        en: 'Enter order number',
    },
    searchOrderButton: {
        ru: 'Проверить статус заказа',
        en: 'Check order status',
    },
    allOrders: {
        ru: 'Все заказы',
        en: 'All orders',
    },
    emptyOrderList: {
        ru: 'У вас еще нет ни одного заказа.',
        en: 'You have no orders yet.',
    },
    table: {
        number: {
            ru: 'Номер',
            en: 'Number',
        },
        equipment: {
            ru: 'Оборудование',
            en: 'Equipment',
        },
        rentalDates: {
            ru: 'Даты аренды',
            en: 'Rental dates',
        },
        rentEnd: {
            ru: 'До конца аренды',
            en: 'Rent end',
        },
        deliveryType: {
            ru: 'Тип доставки',
            en: 'Delivery type',
        },
        status: {
            ru: 'Статус',
            en: 'Status',
        },
        payment: {
            ru: 'Оплата',
            en: 'Payment',
        },
        documents: {
            ru: 'Документы',
            en: 'Documents',
        },
        amount: {
            ru: 'Сумма',
            en: 'Amount',
        },
    },
};
